import { findIndex } from 'lodash';

export default function internalHelper(
  state = {
    content: undefined,
    viewed: false,
    fetched: false,
    showOnLogin: false,
  },
  action,
) {
  switch (action.type) {
    case 'WELCOME_WIDGET/POPULATE_STATE':
      return {
        ...state,
        content: action.data,
        showOnLogin:
          action.data &&
          findIndex(action.data, { viewed: false, showOnLogin: true }) !== -1,
        viewed: action.data && action.data[0] && action.data[0].viewed,
        fetched: true,
      };
    case 'WELCOME_WIDGET/POPULATE_NEED_MARK_VIEWED':
      return {
        ...state,
        viewed: action.status,
        showOnLogin: false,
      };
    default:
      return state;
  }
}
